export function useWordEnding(number: number, endingArray: [string, string, string]): string {
  number = number % 100;

  let ending: string;

  if (number >= 11 && number <= 19) {
    ending = endingArray[2];
  } else {
    switch (number % 10) {
      case 1:
        ending = endingArray[0];
        break;
      case 2:
      case 3:
      case 4:
        ending = endingArray[1];
        break;
      default:
        ending = endingArray[2];
    }
  }

  return ending;
}
